import { render, staticRenderFns } from "./nav-buttons.vue?vue&type=template&id=63a1167b&"
import script from "./nav-buttons.vue?vue&type=script&lang=js&"
export * from "./nav-buttons.vue?vue&type=script&lang=js&"
import style0 from "./nav-buttons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports